import React, { useEffect } from 'react'
import './LeaveReview.sass'
import withStore from '../../../../Components/Unstated/withStore'
import LeaveReviewStore from './Store/LeaveReviewStore'
import ComponentLoader from '../../../../Components/Loading/ComponentLoader'
import LeaveReviewForm from './Components/LeaveReviewForm'
import CourseInfo from './Components/CourseInfo'
import Footer from '../../../../Components/Footer/Footer'
import Success from '../../../../Components/Success/Success'

const LeaveReview = ({
  leaveReviewStore: {
    state: { loading, loadFailed, success },
    init,
  },
  courseURL,
  livDemyID,
}) => {
  useEffect(() => {
    init({ livDemyID, courseURL })
  }, [init, livDemyID, courseURL])

  return (
    <ComponentLoader loading={loading} loadFailed={loadFailed}>
      <>
        <div className='leaveReview'>
          <LeaveReviewForm />
          <CourseInfo />
        </div>
        {success && (
          <Success
            heading={'Your review has been submitted successfully.'}
            subText={
              'Thank you for your time. The review will sent to the teacher and displayed on the platform once reviewed by the admin.'
            }
            primary={{
              name: 'Okay',
              route: '/',
            }}
            secondary={{ hidden: true }}
          />
        )}
        <Footer />
      </>
    </ComponentLoader>
  )
}

export default withStore([LeaveReviewStore])(LeaveReview)
